import { CONTACT, WHATSAPP } from '../../constants';
import './navbar.css';

function Navbar() {
  return (
    <nav className="navbar">
      <div className="container navbar__inner">
        <a href="#hero" className="navbar__logo">EcoClean</a>
        <div className="navbar__links">
          <a href="#products" className="navbar__link">Productos</a>
          <a href="#needs" className="navbar__link">Usos</a>
          <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="navbar__link">{CONTACT.instagramHandle}</a>
          <a href={WHATSAPP.url} target="_blank" rel="noreferrer" className="navbar__cta">WhatsApp</a>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
